export default __webpack_public_path__ + "static/media/BHUTAN AIRLINE LOGO.8aa81c7d.jpg";